import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { Component, Input, Output, OnInit, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ENV } from 'config';
import { ManageInventoryService } from './../shared/providers/manage-inventory.service';
import { KEY_CONFIG } from './../../../../lib/ng2-sapmp/src/config/key-config';

declare var ENV_VAR: any;

@Component({
    selector : 'app-device-lock',
    templateUrl : './device-lock.component.html',
    styleUrls : ['./device-lock.component.scss'],
    providers: [ManageInventoryService],
    encapsulation: ViewEncapsulation.None
})

export class DeviceLockComponent implements OnInit {
    public jsonRes: any;
    public focusAbleElements: any;
    @Input() fan: any;
    @Input() ban: any;
    @Input() ctn: any;
    @Input() triggerElement: any;
    @Output() modalOutput: EventEmitter<boolean>;
    @Output() responseVal: EventEmitter<boolean>;

    constructor(private util: UtilityService, private el: ElementRef,
      private manageInventoryService: ManageInventoryService,
      private router: Router, private pageloaderService: PageLoaderService) {
        this.modalOutput = new EventEmitter<boolean>();
        this.responseVal = new EventEmitter<boolean>();
       manageInventoryService.fetchJSON(this.util.getEnvConfig().contentUrl.manageInventory.deviceLockWipeDetailsUrl).subscribe(resObj => {
        this.jsonRes = resObj;
    });
    }

    ngOnInit() {
        document.body.classList.add('modal-open');
    }

    ok() {
      const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
      const isDisabled = impersonator && impersonator.id ? true : false;
      if (isDisabled) {
        (<HTMLInputElement>document.getElementById('device-lock-btn')).disabled = true;
      } else {
        this.pageloaderService.setPageLoaderStatus(false);
        const currentCtnDetails = JSON.parse(sessionStorage.getItem('currentCtnDetails'));
        this.manageInventoryService.getDeviceLockStatus(currentCtnDetails.emmTenantId, currentCtnDetails.emmDeviceId).
          subscribe(respobj => {
               if (respobj.success) {
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.responseVal.emit(true);
              }else {
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.responseVal.emit(false);
              }this.dimissModal(false);
           }, error => {
          this.handleError(error);
      });
          document.body.classList.remove('modal-open');
      }
    }

    loadFocusTelements() {
        if (!this.focusAbleElements) {
          const focusAbleEls = this.util.getFocusableElements(this.el);
          this.focusAbleElements = Array.prototype.slice.call(focusAbleEls);
          document.getElementById('modalHeading').focus();
        }
      }

      handleKeydown(event) {
        if (event.keyCode === KEY_CONFIG.escapeKey) {
          this.dimissModal(false);
          return;
        }
        this.util.handleKeyPress(event, this.focusAbleElements);
      }
      dimissModal(value, event?) {
        if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          document.body.classList.remove('modal-open');
          this.modalOutput.emit(value);
          this.focusAbleElements = undefined;
          if (this.triggerElement) {
            this.triggerElement.focus();
          }
        }
      }
    cancelModal(value) {
       document.body.classList.remove('modal-open');
       this.modalOutput.emit(value);
       if (this.triggerElement) {
         this.triggerElement.focus();
       }
    }

    handleError(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    throw error;
  }
}
